import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";

const StyledInput = styled.input`
  border-bottom: 2px solid ${(props) => props.theme?.darkPurple} !important;
  &.invalid {
    border-bottom: 2px solid ${(props) => props.theme?.cardinal} !important;
  }
`;

export const EmailInput = (props) => {
  const {
    title,
    margin,
    inputError,
    loginInput,
    value,
    onChange,
    field,
    autoFocus,
    onKeyPress,
  } = props;
  const { t } = useTranslation();

  const innerRef = useRef();

  useEffect(() => {
    if (autoFocus) {
      // this fix the issue with input autofocus when opening a modal
      setTimeout(() => innerRef.current?.focus(), 1);
    }
  }, []);

  return (
    <StyledInput
      data-testid={`email-input${field ? "-" + field : ""}`}
      type="text"
      onKeyPress={onKeyPress}
      id="inputEmail"
      className={`
            form-control
            ${margin || ""}
            ${inputError ? "invalid" : ""}
        `}
      placeholder={title || `${t("appText.email")} ${loginInput ?? ""}`}
      ref={innerRef}
      value={value}
      onChange={(e) => onChange(e)}
      maxLength="128"
    />
  );
};

EmailInput.defaultProps = {
  autoFocus: true,
};

export default withTheme(EmailInput);
